import { Card, CardContent, Typography } from '@mui/material';
import { FunctionComponent } from 'react';

type TicketsSoldCardProps = {
    ticketsSold: number;
    description: string;
};

export const TicketSoldCard: FunctionComponent<TicketsSoldCardProps> = ({
    ticketsSold,
    description,
}) => {
    return (
        <Card sx={{ bgcolor: 'primary.dark' }}>
            <CardContent
                sx={{
                    height: { xs: '120px', sm: '160px' },
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    color: '#fff',
                    py: 2,
                    '&:last-child': { pb: 2 },
                }}
            >
                <Typography variant='h4' sx={{ mb: 1 }}>
                    {ticketsSold}
                </Typography>
                <Typography variant='body2' sx={{ textAlign: 'center' }}>
                    {description}
                </Typography>
            </CardContent>
        </Card>
    );
};
